import { InputText, InputTextProps } from "primereact/inputtext";
import styles from "./styles.module.css";

type Props = {
  label?: string;
} & InputTextProps;

export function Input({ label, disabled, className, ...props }: Props) {
  return (
    <div className="flex flex-column align-items-start">
      {label && (
        <label
          htmlFor="username"
          className={[styles.inputLabel, disabled ? "opacity-50" : ""].join(
            " "
          )}
        >
          {label}
        </label>
      )}
      <InputText {...props} disabled={disabled} className={[className, styles.inputHover].join(" ")} />
    </div>
  );
}
